// views/Dashboard/PainelExecutivo/components/FiltrosGlobaisDashboard.tsx
import React, { useState } from 'react';
import type { FiltrosDashboard } from '../types';
import SeletorPeriodoDashboard from './SeletorPeriodoDashboard';

interface Props {
  filtros: FiltrosDashboard;
  onChange: (filtros: FiltrosDashboard) => void;
  /** Filtros da área aberta (canal de venda no Comercial, base de data no
   *  Financeiro). Ficam nesta mesma linha, para não haver duas faixas de filtro. */
  filtrosDaArea?: React.ReactNode;
}

// Bloco normal, não fixo no topo: a barra sticky roubava altura em toda rolagem
// e, no celular, empurrava o conteúdo para baixo da dobra. Os filtros ficam
// logo abaixo das abas, coladas no conteúdo que elas recortam.
const FiltrosGlobaisDashboard: React.FC<Props> = ({ filtros, onChange, filtrosDaArea }) => {
  const [comparando, setComparando] = useState(!!filtros.periodoComparacao);

  const toggleComparacao = () => {
    if (comparando) {
      setComparando(false);
      onChange({ ...filtros, periodoComparacao: null });
    } else {
      setComparando(true);
      onChange({ ...filtros, periodoComparacao: { tipo: 'preset', preset: 'mesAnterior' } });
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col lg:flex-row lg:flex-wrap gap-3 lg:items-center">
        {/* O botão de comparar entra na linha do campo de período — no celular,
            solto aqui, ele ocupava uma linha inteira só para ele. */}
        <SeletorPeriodoDashboard
          periodo={filtros.periodo}
          onChange={(periodo) => onChange({ ...filtros, periodo })}
          acessorio={
            <button
              type="button"
              onClick={toggleComparacao}
              aria-label={comparando ? 'Remover comparativo' : 'Comparar com outro período'}
              className={`whitespace-nowrap px-3 py-2.5 sm:py-1.5 rounded-xl sm:rounded-full text-xs font-semibold border transition-colors ${
                comparando
                  ? 'bg-primary/10 text-primary border-primary/30'
                  : 'text-gray-500 dark:text-gray-400 border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700'
              }`}
            >
              {/* Texto curto no celular, para caber ao lado da lista. */}
              <span className="sm:hidden">{comparando ? '✕ Comparativo' : '+ Comparar'}</span>
              <span className="hidden sm:inline">{comparando ? '✕ Remover comparativo' : '+ Comparar com outro período'}</span>
            </button>
          }
        />

        {filtrosDaArea && <div className="lg:ml-auto flex flex-wrap items-center gap-2">{filtrosDaArea}</div>}
      </div>

      {comparando && filtros.periodoComparacao && (
        <div className="flex flex-wrap items-center gap-2 border-t border-gray-100 dark:border-gray-800 pt-3">
          <span className="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide shrink-0">Período B</span>
          <SeletorPeriodoDashboard
            periodo={filtros.periodoComparacao}
            onChange={(periodoComparacao) => onChange({ ...filtros, periodoComparacao })}
          />
        </div>
      )}
    </div>
  );
};

export default FiltrosGlobaisDashboard;
